module.exports = __webpack_public_path__ + "img/check.d64b44fa.svg";